import style from './NotificationCenterPage.css';
import useConfig from '../../config/config.context';
import { renderIf } from '../../utils/render.utils';
import CaasStorageKeys from '../../constants/caas.storage.keys';
import { ConsoleEvent } from '../../sdk/console.event';
import NotificationCenterListing from '../../components/NotificationCenter/NotificationCenterListing/NotificationCenterListing';
import EmptyNotificationsList from '../../components/NotificationCenter/EmptyNotificationsList/EmptyNotificationsList';
import AppBar from '../../components/shared/AppBar/AppBar';
import { useEffect, useRef, useState } from 'preact/hooks';
import NavigationUtils from '../../utils/navigation.utils';
import useTranslation from '../../localization/i18n.context';
import useAndroidBackPress from '../../hooks/back.listener.hook';

const handleBackClick = () => {
  NavigationUtils.back();
};

export default function NotificationCenterPage() {
  const { config, updateConfigByKey } = useConfig();
  const [notifications, setNotifications] = useState(
    config[CaasStorageKeys.NOTIFICATIONS] !== undefined
      ? config[CaasStorageKeys.NOTIFICATIONS]
      : [],
  );
  const backRef = useRef(null);
  const { t } = useTranslation();

  useAndroidBackPress(backRef.current, () => {
    backRef.current.props.onClick();
  });

  const handleNotificationCenterRefresh = e => {
    updateConfigByKey(e.detail.eventData)
      .then(newConfig => {
        setNotifications(
          newConfig[CaasStorageKeys.NOTIFICATIONS] !== undefined
            ? newConfig[CaasStorageKeys.NOTIFICATIONS]
            : [],
        );
      })
      .catch(e => {
        ConsoleEvent.log(`Error occurred updating the config keys. ${e}`);
      });
  };

  // update home page cotent on request
  useEffect(() => {
    document.addEventListener(
      window.__CAAS__.events.refreshPage,
      handleNotificationCenterRefresh,
    );

    return () => {
      document.removeEventListener(
        window.__CAAS__.events.pressBack,
        handleNotificationCenterRefresh,
      );
    };
  }, []);

  return (
    <>
      <AppBar
        onBackClick={handleBackClick}
        className="fixed-bar"
        title={t('Notifications')}
        backRef={backRef}
      />
      <>
        {renderIf(
          !notifications.length,
          <div className={style.bottomContainer}>
            {' '}
            <EmptyNotificationsList />
          </div>,
        )}
        {renderIf(
          notifications.length,
          <div className={style.container}>
            {renderIf(
              notifications.length,
              <NotificationCenterListing notifications={notifications} />,
            )}

            {renderIf(!notifications.length, <EmptyNotificationsList />)}
          </div>,
        )}
      </>
    </>
  );
}
